import axios from 'axios'

const baseDomain = import.meta.env.VITE_OI_SERVICE_BASE_URL
const baseURL = `${baseDomain}`

const httpClient = axios.create({
  baseURL,
})

export default httpClient
